import * as React from "react";

import style from "./storylane-video.scss";
import { LoadingIndicator } from "components/loading-indicator/LoadingIndicator";
import { RepositoryKey, setObject } from "utils/repository";

interface Props {
    linkUrl: string;
}

export default function StorylaneVideo(props: Props) {
    const [isLoading, setIsLoading] = React.useState(true);

    React.useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://js.storylane.io/js/v2/storylane.js";
        script.async = true;
        document.head.appendChild(script);

        // The iframe's onLoad event doesn't accurately reflect when the video content is ready, causing the loading
        // indicator to persist even after the iframe loads. Therefore, using a fixed 500ms timeout
        const timer = setTimeout(() => setIsLoading(false), 500);
        return () => {
            script.remove();
            clearTimeout(timer);
            if (props.linkUrl === "https://blancco.storylane.io/share/bmp-gettingstarted") {
                setObject(RepositoryKey.TRIAL_ONBOARDING_POPUP, false);
            }
        };
    }, []);

    return (
        <>
            <div className={style.slEmbed}>
                {isLoading && (
                    <div className={style.loadingContainer}>
                        <LoadingIndicator small={true} />
                    </div>
                )}
                <iframe
                    loading="eager"
                    className={style.slDemo}
                    src={props.linkUrl}
                    name="sl-embed"
                    allow="fullscreen"
                    allowFullScreen
                />
            </div>
        </>
    );
}
